import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

// 실제 문제가 있는 인앱 브라우저만 감지 (더 엄격한 조건)
const isProblematicInAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Google OAuth에서 실제로 문제가 되는 브라우저만 감지
  const isProblematic = (
    /FBAN|FBAV/i.test(userAgent) || // Facebook 앱 (확실히 문제됨)
    /Instagram/i.test(userAgent) || // Instagram 앱 (확실히 문제됨)
    /KAKAOTALK/i.test(userAgent) || // 카카오톡 앱
    /LINE/i.test(userAgent) || // 라인 앱
    userAgent.includes('GSA/') // Google Search App (구글에서 차단)
    // WeChat, Twitter, WhatsApp 등은 제거 - 대부분 OAuth 지원함
    // Android WebView 조건도 제거 - 정상 브라우저와 구분 어려움
  );
  
  console.log('🔍 GoogleSignInButton 문제 브라우저 감지:', {
    userAgent: userAgent,
    isProblematic: isProblematic
  });
  
  return isProblematic;
};

const GoogleSignInButton = ({ disabled = false }) => {
  const { loginWithGoogle } = useAuth();
  const [isClicked, setIsClicked] = useState(false);

  const handleClick = async () => {
    if (disabled) return;
    
    // 정말 문제가 있는 브라우저에서만 경고 표시 (경고 메시지도 완화)
    if (isProblematicInAppBrowser()) {
      console.warn('⚠️ 문제가 있을 수 있는 브라우저에서 로그인 시도');
      // confirm 대신 콘솔 경고만 표시하고 계속 진행
      // 사용자 경험을 위해 팝업 제거
    }
    
    setIsClicked(true);
    
    try {
      await loginWithGoogle();
    } catch (error) {
      // 에러는 AuthContext에서 처리됨
      console.error('로그인 버튼 클릭 에러:', error);
    } finally {
      setIsClicked(false);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={disabled || isClicked}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        width: '100%',
        padding: '12px 24px',
        backgroundColor: disabled || isClicked ? '#f5f5f5' : '#4285f4',
        color: disabled || isClicked ? '#9e9e9e' : 'white',
        border: 'none',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '500',
        cursor: disabled || isClicked ? 'not-allowed' : 'pointer',
        transition: 'all 0.2s ease',
        outline: 'none',
        boxShadow: disabled || isClicked 
          ? 'none' 
          : '0 2px 4px rgba(0, 0, 0, 0.1)',
        ...(!(disabled || isClicked) && {
          ':hover': {
            backgroundColor: '#3367d6',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)'
          }
        })
      }}
      onMouseEnter={(e) => {
        if (!(disabled || isClicked)) {
          e.target.style.backgroundColor = '#3367d6';
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.15)';
        }
      }}
      onMouseLeave={(e) => {
        if (!(disabled || isClicked)) {
          e.target.style.backgroundColor = '#4285f4';
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
        }
      }}
    >
      {/* Google 아이콘 */}
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      
      {/* 버튼 텍스트 */}
      <span>
        {isClicked ? '로그인 중...' : 'Google로 로그인'}
      </span>
    </button>
  );
};

export default GoogleSignInButton;
